import React from 'react';

interface MultiLanguageContextProps {
  setLanguage(language: string): void;
  language?: string;
  isTranslation: boolean;
  projectLanguageOptions: { original: boolean; language: string; id: string }[];
}

const MultiLanguageContext = React.createContext<MultiLanguageContextProps | null>(null);
export default MultiLanguageContext;
